import { useReducer } from 'react';
import {
    type PromoCodeFilteringRule,
    PromoCodeSortingField,
    type PromoCodeSortingRule,
    SortingOrder,
} from '../../../api/types';
import {
    type ExtendedPageState,
    type ExtendedPageAction,
    extendedReducer,
} from '../../../components/PaginatedTableWithContext';
import { type SortOrderValue } from '../../../utilities/useSortAndFilterCache';

type SortRule = PromoCodeSortingRule & SortOrderValue;
export type State = ExtendedPageState & {
    sort: SortRule;
    filter: PromoCodeFilteringRule;
};

export type SetSortAction = { type: 'setSort'; sort: SortRule };
export type SetFilterAction = { type: 'setFilter'; filter: PromoCodeFilteringRule };
export type Action = ExtendedPageAction | SetSortAction | SetFilterAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'setPage':
            return { ...state, page: action.page };

        case 'setPageSize':
            return { ...state, page: 0, pageSize: action.pageSize };

        case 'setSort':
            return { ...state, page: 1, sort: action.sort };

        case 'setFilter':
            return { ...state, page: 1, filter: action.filter };

        default:
            return extendedReducer(state, action);
    }
};
const useListReducer = (cache?: State) =>
    useReducer(reducer, {
        companyId: cache?.companyId,
        // default pagination
        page: cache?.page || 1,
        pageSize: cache?.pageSize || 10,

        // default sorting
        sort: cache?.sort || {
            field: PromoCodeSortingField.PromoCode,
            order: SortingOrder.Asc,
            orderValue: undefined,
        },

        filter: cache?.filter || null,
    });

export default useListReducer;
